import React, { useEffect, useState } from 'react';

import CancelOperator from '../../Components/CancelOperator';
import ModalWarn from '../../Components/Modal/Warn/index'

export default function CancelAttendant(props) {
    const [ attendant, setAttendant ] = useState({
        cpf: '',
        name: '',
        organ: '',
        dt_inc: '',
        dt_canc_exp: ''
    });
    const [ loadAttendant, setLoadAttendant ] = useState(false);
    const [ rangePages, setRangePages ] = useState({
        label: "10", value: "10"
    });
    const [modalInvalidSessionError, setModalInvalidSessionError] = useState(false)
    const [modalInvalidSessionErrorTitle, setModalInvalidSessionErrorTitle] = useState(null)
    const [modalInvalidSessionErrorMsg, setModalInvalidSessionErrorMsg] = useState(null)

    useEffect(() => {
        if (!loadAttendant && props.location.state !== undefined) {
            setAttendant({
                cpf: props.location.state.result_search.CPF_USUARIO,
                name: props.location.state.result_search.NOME_USUARIO,
                organ: {
                    value: props.location.state.result_search.CODIGO_ORGAO,
                    label: props.location.state.result_search.NOME_ORGAO
                },
                unidade: {
                    // value: props.location.state.result_search.unidades[0].CODIGO_UNIDADE,
                    label: props.location.state.result_search.unidades[0].NOME_UNIDADE
                },
                dt_inc: props.location.state.result_search.DATA_INCLUSAO,
                dt_canc_exp: props.location.state.result_search.DATA_CANCELAMENTO
            });

            setLoadAttendant(true);
        }
    }, [props, loadAttendant]);

    const [ isModalConfirmVisible, setModalConfirmVisible ] = useState(false);

    const [ loadingCancel, setLoadingCancel ] = useState(false);
    const [ canceled, setCanceled ] = useState(false);

    const [ modalError, setModalError ] = useState(false);
    const [ messageError, setMessageError ] = useState("");

    const onSubmitCancel = async () => {

        setLoadingCancel(true);

        const requestOptions = {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).token : "",
                'codigoUnidade': JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : undefined //Necessário para a validação de acesso à unidade no VerifyAccess.js
            }),
            body: JSON.stringify({
                cpf_gestor: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).cpf_atendente : "",
                id_usuario_orgao: props.location.state.result_search.ID_USUARIO_ORGAO,
                cpf_usuario_atendente: attendant.cpf,
                codigo_orgao: attendant.organ.value,
                codigo_unidade: JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).codigo_unidade : ""
            }),
        };
        
        await fetch(`${process.env.REACT_APP_API_URL}/gestao/cancelaatendente`, requestOptions).then(
            function(response) {
            if (response.ok) {
                response.json().then(function() {
                    
                    setCanceled(true);
                    setLoadingCancel(false);
                    setModalConfirmVisible(false)
                });
            } else if (response.status === 422) {
                response.json().then(function(data) {
                    if (!!data.errorCode && !!data.message) {
                        // inserir a mensagem: data.message no aviso de erro
                        setMessageError(data.message);
                        setModalError(true);
                    } else {
                        // inserir mensagem genérica
                        setMessageError('Houve algum problema no servidor.');
                        setModalError(true);
                        console.log('Response error in /gestao/cancelaatendente BackendBalcao');
                    }

                    setLoadingCancel(false);
                });
            } else if (response.status === 403) {
                response.json().then(function (data) {
                  setModalInvalidSessionErrorTitle(data.title ? data.title : null)
                  setModalInvalidSessionErrorMsg(data.message ? data.message : null)
                  setLoadingCancel(false);
                  setModalInvalidSessionError(true)
                })
            } else {
                setMessageError('Houve algum problema no servidor. Aguarde um momento e tente novamente.');
                setModalError(true);
                setLoadingCancel(false);
                console.log('Error request to /gestao/cancelaatendente');
            }
        }).catch(function(err) {
            console.error('Failed retrieving information', err);
        });
    }

    return (
        <>
            <ModalWarn
                id='modalWarnalertInvalidSession'
                appear={modalInvalidSessionError}
                title = { modalInvalidSessionErrorTitle }
                text={ modalInvalidSessionErrorMsg ? modalInvalidSessionErrorMsg : 'Este acesso foi transferido para outro dispositivo.'}
                textButton2='Ir para tela inicial'
                actionButton2={() => { 
                    document.getElementById("btnLogout").click();
                }}
            />
            <CancelOperator
                pageTitle='Desvincular atendente desta unidade'
                confirmationMsg='Tem certeza que deseja desvincular este atendente?'
                successMsg='Atendente desvinculado desta unidade com sucesso'
                operator={attendant}
                setOperator={setAttendant}
                loadOperator={loadAttendant}
                isModalConfirmVisible={isModalConfirmVisible}
                setModalConfirmVisible={setModalConfirmVisible}
                loadingCancel={loadingCancel}
                setLoadingCancel={setLoadingCancel}
                canceled={canceled}
                setCanceled={setCanceled}
                modalError={modalError}
                setModalError={setModalError}
                messageError={messageError}
                setMessageError={setMessageError}
                onSubmitCancel={onSubmitCancel}
                history={props.history}
                location={props.location}
                buttonBackRoute='/gerenciaratendentes'
                rangePages={rangePages}
                setRangePages={setRangePages}
            />
        </>
    );
}